export default "__VITE_ASSET__DcAwLaKb__"